import types from './types'

const setToken = (state, token) => { state.token = token }
const setUser = (state, data) => { state.user = data }
const logoutUser = state => { state.user = null }

export default {
    [types.SET_JWT_TOKEN]: setToken,
    [types.SET_USER]: setUser,
    [types.LOGOUT_USER]: logoutUser
}
